<div class="card hover-show w-100">
    <div class="card-body">
        <app-confirmation-toggle (confirmed)="deleteApiKey()">
            <button type="button" class="btn position-absolute top-0 start-0 to-show"
                    role="button" aria-expanded="false">
                <i class="bi bi-trash"></i>
            </button>
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Delete API key</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Are you sure you want to delete this API key? Deleting it will prevent future requests from being processed, which may disrupt existing integrations with our API.</p>
                </div>
                <div class="modal-footer justify-content-between">
                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                    <button type="button" class="btn btn-primary" (click)="deleteApiKey()" data-bs-dismiss="modal">
                        Delete API key
                    </button>
                </div>
            </div>
        </app-confirmation-toggle>
        <div class="position-absolute top-0 end-0 d-flex align-items-center gap-2">
            <app-confirmation-toggle (confirmed)="cycleApiKey()">
                <button type="button" class="btn to-show" role="button" data-bs-title="Cycle API key"
                        aria-expanded="false">
                    <i class="bi bi-arrow-clockwise"></i>
                </button>
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Cycle API key</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>This will cause the old key to not work anymore. Are you sure you want to cycle this
                            key?</p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                        <button type="button" class="btn btn-primary" (click)="cycleApiKey()"
                                data-bs-dismiss="modal">
                            Cycle API key
                        </button>
                    </div>
                </div>
            </app-confirmation-toggle>
            <button type="button" class="btn to-show" role="button" aria-expanded="false" (click)="openKeyDetails()">
                <i class="bi bi-pencil"></i>
            </button>
        </div>
        <h2 class="card-title text-center notranslate mt-3 d-flex align-items-center justify-content-center text-truncate">
            <i class="bi bi-card-text me-2"></i>
            <span class="vertical-align-middle notranslate">{{ apiKey.description }}</span>
        </h2>
        <h4 class="text-muted text-center">
            <svg fill="#6c757d" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 48.502 48.502" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"/>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                <g id="SVGRepo_iconCarrier"><g><path d="M36.12 6.89c-1.466 0 -2.845 0.571 -3.882 1.608 -2.14 2.14 -2.14 5.623 0 7.763 1.037 1.037 2.415 1.608 3.881 1.608s2.845 -0.571 3.882 -1.608c2.14 -2.14 2.14 -5.623 0 -7.763 -1.037 -1.037 -2.415 -1.608 -3.881 -1.608m1.76 7.25c-0.47 0.47 -1.095 0.729 -1.76 0.729s-1.29 -0.259 -1.76 -0.729c-0.971 -0.971 -0.971 -2.55 0 -3.521 0.47 -0.47 1.095 -0.729 1.76 -0.729s1.29 0.259 1.76 0.729c0.971 0.971 0.971 2.55 0 3.52"/><path
                        d="M44.196 4.304C41.421 1.528 37.731 0 33.806 0s-7.615 1.528 -10.39 4.304c-4.223 4.223 -5.449 10.518 -3.207 15.97L0.025 40.458l-0.017 8.027 14.456 0.017v-5.572h5.571V37.359h5.571v-6.449l2.621 -2.621c1.761 0.72 3.67 1.098 5.58 1.098 3.924 0 7.614 -1.528 10.389 -4.303 5.729 -5.729 5.729 -15.05 0 -20.779m-2.121 18.658c-2.208 2.208 -5.145 3.425 -8.268 3.425 -1.813 0 -3.624 -0.426 -5.235 -1.233l-0.967 -0.484 -4.999 4.998v4.692h-5.571v5.571h-5.571v5.569l-8.45 -0.01 0.008 -3.785L23.831 20.895l-0.484 -0.967c-2.257 -4.509 -1.377 -9.935 2.191 -13.503C27.747 4.216 30.683 3 33.806 3s6.06 1.216 8.268 3.425c4.559 4.559 4.559 11.978 0 16.537"/></g></g></svg>
            <span class="ms-2 text-truncate notranslate">{{ apiKey.keyId }}</span>
        </h4>
        <h5 class="text-muted text-center">
            <i class="bi bi-calendar-check me-2 "></i>
            <span class="vertical-align-middle notranslate">{{ apiKey.timestamp | date: 'medium' }}</span>
        </h5>
    </div>
</div>